import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { isPhoneNumberValid } from '../../../Constant.js'
import axios from 'axios'
class ShopOwnerAdding extends React.Component {
  state = {
    first_name: '',
    last_name: '',
    first_name_ar: '',
    last_name_ar: '',
    phone: '',
    email: '',
    password: '',
    user_profile: '',
    country_code: '',
    isData: false,
    listCountries: [],
  }
  countryList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/auth/list-countries?show_all_countries=true', {
        headers: { country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            listCountries: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  componentDidMount() {
    this.countryList()
    this.getShopOwner()
  }
  getShopOwner = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-users/shop-owner', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.Vendors_ids)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
          this.setState({ Edit: true })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    this.dashbord()
  }
  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }
  dashbord = async () => {
    let number_validation = isPhoneNumberValid(this.state.phone, localStorage.getItem('countryShortName'))

    if (!number_validation.valid) {
      document.getElementById('phone')?.focus()
      this.setState({ isSaving: false })
      Swal.fire({
        title: number_validation.msg,
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    const formData = new FormData()

    formData.append('first_name', this.state.first_name)
    formData.append('last_name', this.state.last_name)
    formData.append('first_name_ar', this.state.first_name_ar)
    formData.append('last_name_ar', this.state.last_name_ar)
    formData.append('phone', this.state.phone)
    formData.append('email', this.state.email)
    formData.append('password', this.state.password)
    let selectedCountryCode = localStorage.getItem('countryShortName')
    let getSingleCountryDetails =
      this.state.listCountries &&
      this.state.listCountries.length &&
      this.state.listCountries.find((country) => country.country_short_name === selectedCountryCode)
    let countryCode = ''
    let countryName = ''
    if (getSingleCountryDetails) {
      countryCode = getSingleCountryDetails.country_code
      countryName = getSingleCountryDetails.country_short_name
    }

    if (countryCode) {
      formData.append('country_code', `+${countryCode.replace(/\+/g, '')}`)
    }

    formData.append('country', countryName)
    this.setState({ isData: true })

    if (this.props.Vendors_ids) {
      formData.append('userId', this.props.Vendors_ids)
      if (this.state.user_profile?.name) {
        formData.append('user_profile', this.state.user_profile)
      }
      await axios
        .post(Constant.getAPI() + '/user/update-user', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.setState({ isData: false })
          Swal.fire({
            title: 'vendor Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = '#/vendors'
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      formData.append('user_profile', this.state.user_profile)
      await axios
        .post(Constant.getAPI() + '/shop/create-shop-owner', formData, {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          Swal.fire({
            title: 'Shop Owner Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.setState({ isData: false })
          window.location.href = '#/shop-owner'
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">First Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    id="first_name"
                    placeholder="First Name: English"
                    onChange={this.handleChange}
                    value={this.state.first_name}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">First Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="first_name_ar"
                    id="first_name_ar"
                    placeholder="First Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.first_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Last Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    id="last_name"
                    placeholder="Last Name: English"
                    onChange={this.handleChange}
                    value={this.state.last_name}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Last Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="last_name_ar"
                    id="last_name_ar"
                    placeholder="Last Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.last_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Email</label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Email"
                    onChange={this.handleChange}
                    value={this.state.email}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Phone No</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="phone"
                    id="phone"
                    placeholder="Phone No"
                    onChange={this.handleChange}
                    value={this.state.phone}
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
							<div className="form-group row">
								<label className="col-sm-3 col-form-label">Country Code</label>
								<div className="col-sm-9">
									<select
										name="country_code"
										className="form-control"
										onChange={this.handleChange}
										value={this.state.country_code}
									>
										<option value="">Select Country Code</option>
										<option value="+965"> +965</option>
									</select>
								</div>
							</div>
						</div> */}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Password</label>
                <div className="col-sm-9">
                  <input
                    type="password"
                    className="form-control"
                    autoComplete="new-password"
                    name="password"
                    id="password"
                    placeholder="Password"
                    onChange={this.handleChange}
                    value={this.state.password}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="user_profile"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.user_profile}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button
                className="btn btn-grd-disabled mr-2"
                disabled
              >
                Saving...!
              </button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={'/vendors'}
              className="btn btn-outline-dark"
            >
              {' '}
              Cancel{' '}
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default ShopOwnerAdding
